var FavouriteShop;
(function (FavouriteShop) {
    myonce('favouriteShop', () => {
        const $favouriteShop = document.querySelector('#favourite-shop');
        let storeRegistry = {};
        let positionCoordLat;
        let positionCoordLong;
        if ($favouriteShop) {
            const $storesWrapper = $favouriteShop.querySelector('.favourite');
            const $storeDummy = $storesWrapper.querySelector('.my-shop-card');
            const $offersWrapper = $favouriteShop.querySelector('.offers');
            const $offerDummy = $offersWrapper.querySelector('.offer-default.dummy');
            const $servicesWrapper = $favouriteShop.querySelector('.wrapper-shop-online');
            const $serviceDummy = $servicesWrapper.querySelector('.slide.dummy');
            const $switchClosest = $favouriteShop.querySelector('.switch-closest');
            const $switchFavourite = $favouriteShop.querySelector('.switch-favourite');
            const $titleClosest = $favouriteShop.querySelector('.title-closest');
            const $titleFavourite = $favouriteShop.querySelector('.title-favourite');
            const $subHeader = $favouriteShop.querySelector('.sub-head');
            const $button = $favouriteShop.querySelector('.container-btn');
            const $next = $storesWrapper.querySelector('.carousel__button--next');
            const $prev = $storesWrapper.querySelector('.carousel__button--prev');
            let activeStoreIndex = 0;
            function getSchedule(store) {
                let result = 'Chiuso';
                let now = new Date();
                let extraordinary = store.extraordinary_schedules &&
                    store.extraordinary_schedules.find(extraDay => {
                        let extraDayTime = new Date(extraDay.date);
                        return (extraDayTime.getFullYear() +
                            '/' +
                            extraDayTime.getMonth() +
                            '/' +
                            extraDayTime.getDate() ===
                            now.getFullYear() + '/' + now.getMonth() + '/' + now.getDate());
                    });
                let ordinary = store.schedules &&
                    store.schedules.find(ordDay => {
                        return now.getDay() + 1 === ordDay.dayOfTheWeek;
                    });
                let checkDay = extraordinary || ordinary;
                let searchNextDay = false;
                if (checkDay && checkDay.status) {
                    let daySegments = checkDay.value.split(';').map(segment => {
                        return segment.split('-');
                    });
                    let isOpen = false;
                    let afterSegments = [];
                    daySegments.forEach((segment, index) => {
                        let startDate = new Date();
                        startDate.setHours(segment[0].split(':')[0]);
                        startDate.setMinutes(segment[0].split(':')[1]);
                        startDate.setSeconds(0);
                        let endDate = new Date();
                        endDate.setHours(segment[1].split(':')[0]);
                        endDate.setMinutes(segment[1].split(':')[1]);
                        endDate.setSeconds(0);
                        afterSegments[index] = now > endDate;
                        if (now >= startDate && now <= endDate) {
                            isOpen = true;
                            result = 'Aperto ora - Chiusura: ' + segment[1];
                        }
                    });
                    if (!isOpen) {
                        let segmentIndex = afterSegments.indexOf(false);
                        if (segmentIndex > 0) {
                            result += ' - Apertura: ' + daySegments[segmentIndex][0];
                        }
                        else {
                            searchNextDay = true;
                        }
                    }
                }
                else {
                    searchNextDay = true;
                }
                if (searchNextDay) {
                    let nextDayDate = new Date();
                    let nextIndex = 1;
                    let nextDay;
                    while (!nextDay && nextIndex <= 7) {
                        nextDayDate.setDate(now.getDate() + nextIndex);
                        let nextExtraordinary = store.extraordinary_schedules &&
                            store.extraordinary_schedules.find(extraDay => {
                                let extraDayTime = new Date(extraDay.date);
                                return (extraDayTime.getFullYear() +
                                    '/' +
                                    extraDayTime.getMonth() +
                                    '/' +
                                    extraDayTime.getDate() ===
                                    nextDayDate.getFullYear() +
                                        '/' +
                                        nextDayDate.getMonth() +
                                        '/' +
                                        nextDayDate.getDate());
                            });
                        let nextOrdinary = store.schedules &&
                            store.schedules.find(ordDay => {
                                return nextDayDate.getDay() + 1 === ordDay.dayOfTheWeek;
                            });
                        let nextCheckDay = nextExtraordinary || nextOrdinary;
                        if (nextCheckDay && nextCheckDay.status) {
                            nextDay = nextCheckDay;
                            nextDay.date = nextDayDate;
                        }
                        else {
                            nextIndex++;
                        }
                    }
                    if (nextDay) {
                        let days = [
                            'Domenica',
                            'Lunedì',
                            'Martedì',
                            'Mercoledì',
                            'Giovedì',
                            'Venerdì',
                            'Sabato',
                        ];
                        let dayName = days[nextDay.date.getDay()];
                        let openingTime = nextDay.value.split('-')[0];
                        result += ' - Apertura: ' + dayName + ' ' + openingTime;
                    }
                }
                return result;
            }
            function showSearch() {
                $favouriteShop.querySelector('.no-shop').classList.add('is-active');
            }
            function retrieveConfig($wrapper) {
                let data = {
                    url: '',
                    config: {},
                };
                const $form = $wrapper && $wrapper.querySelector('.ep-config');
                if ($form) {
                    try {
                        const url = $form.querySelector('[name="url"]').value;
                        const config = $form.querySelector('[name="config"]').value;
                        data = {
                            url: url.replace(/\/$/, ''),
                            config: JSON.parse(config),
                        };
                    }
                    catch (e) {
                        console.log('Error during retrieval of configuration for current service. %s', e);
                    }
                }
                return data;
            }
            function getClosestShop({ latitude, longitude }) {
                return new Promise((resolve, reject) => {
                    let closestStore = JSON.parse(sessionStorage.getItem('closest-store'));
                    if (!closestStore) {
                        const config = retrieveConfig($favouriteShop);
                        Fetch('/api/esb/storelocator/searchStores?_format=form', {
                            method: 'POST',
                            data: {
                                coords: {
                                    latitude,
                                    longitude,
                                },
                            },
                            token: { enable: true }
                        })
                            .then(response => {
                            resolve(response);
                            if (response.result === 'OK') {
                                sessionStorage.setItem('closest-store', JSON.stringify(response));
                            }
                        })
                            .catch(() => {
                            reject();
                        });
                    }
                    else {
                        resolve(closestStore);
                    }
                });
            }
            function getStores(getClosest) {
                $storesWrapper.setAttribute('data-spinner', '');
                return new Promise((resolve, reject) => {
                    localforage.getItem('favourite_store').then(stores => {
                        if (stores && stores.length && !getClosest) {
                            resolve(stores);
                            $titleFavourite.classList.remove('d-none');
                            getCoords()
                                .then(position => {
                                if (position.coords) {
                                    $switchClosest.classList.add('is-active');
                                    $subHeader.classList.remove('d-none');
                                }
                            }).catch(() => {
                                $subHeader.classList.add('d-none');
                            });
                        }
                        else {
                            $titleClosest.classList.remove('d-none');
                            $subHeader.classList.remove('d-none');
                            getCoords()
                                .then(position => {
                                getClosestShop(position.coords)
                                    .then((response) => {
                                    if (response &&
                                        response.header.result === 'OK' &&
                                        response.payload.stores.length) {
                                        resolve([response.payload.stores[0]]);
                                    }
                                    else {
                                        reject();
                                    }
                                })
                                    .catch(() => {
                                    reject();
                                })
                                    .finally(() => {
                                    localforage.getItem('favourite_store').then(stores => {
                                        if (stores && stores.length) {
                                            $switchFavourite.classList.add('is-active');
                                        }
                                    });
                                });
                            })
                                .catch(() => {
                                showSearch();
                                $switchClosest.classList.remove('is-active');
                                $switchFavourite.classList.remove('is-active');
                                reject();
                            });
                        }
                    });
                }).finally(() => {
                    $storesWrapper.removeAttribute('data-spinner');
                });
            }
            function getOffers(coopId, pdvId) {
                return new Promise(resolve => {
                    let offers = JSON.parse(sessionStorage.getItem('offers-cache')) || {};
                    if (offers[pdvId]) {
                        resolve(offers[pdvId]);
                    }
                    else {
                        const config = retrieveConfig($favouriteShop);
                        Fetch('/api/esb/storelocator/getStoreDetail?_format=form', {
                            method: 'POST',
                            data: {
                                storeId: [pdvId]
                            },
                            token: { enable: true }
                        }).then(response => {
                            if (response && response.header.result === 'OK') {
                                offers[pdvId] = [];
                                response.payload.stores[0].flyers.forEach(offer => {
                                    offers[pdvId].push(offer);
                                });
                                sessionStorage.setItem('offers-cache', JSON.stringify(offers));
                                return response.payload.stores[0].flyers;
                            }
                            else {
                                return [];
                            }
                        })
                            .catch(() => {
                            return [];
                        })
                            .then(offers => {
                            resolve(offers);
                        });
                    }
                });
            }
            function getServices(id, { latitude, longitude }) {
                return new Promise(resolve => {
                    let services = JSON.parse(sessionStorage.getItem('services-cache')) || {};
                    if (services[id]) {
                        resolve(services[id]);
                    }
                    else {
                        getZipCode({ latitude, longitude })
                            .then((zipCode) => {
                            return zipCode || '';
                        })
                            .catch(() => { }) 
                            .then(zipCode => {
                            const config = retrieveConfig($favouriteShop);
                            Fetch('/api/esb/geolink/getGeoLinks?_format=form', {
                                method: 'POST',
                                data: {
                                    latitude,
                                    longitude,
                                    zipCode,
                                    type: 'HP',
                                },
                                token: { enable: true }
                            })
                                .then(response => {
                                if (response && response.header.result === 'OK') {
                                    services[id] = [];
                                    response.payload.services.forEach(service => {
                                        services[id].push(service);
                                    });
                                    sessionStorage.setItem('services-cache', JSON.stringify(services));
                                    return response.payload.services;
                                }
                                else {
                                    return [];
                                }
                            })
                                .catch(() => {
                                return [];
                            })
                                .then(services => {
                                resolve(services);
                            });
                        });
                    }
                });
            }
            function buildStoreHtml($dummy, store) {
                const $store = $dummy.cloneNode(true);
                getCoords()
                    .then(position => {
                    positionCoordLat = position.coords.latitude;
                    positionCoordLong = position.coords.longitude;
                    $store.querySelector('.promotion-wrapper .links .directions').href =
                        `https://www.google.it/maps/dir/${positionCoordLat},${positionCoordLong}/${store.geo.latitude},${store.geo.longitude}`;
                    initLink();
                })
                    .catch((e) => {
                    console.log(e);
                    $store.querySelector('.promotion-wrapper .links .directions').href =
                        `https://www.google.it/maps/dir//${store.geo.latitude},${store.geo.longitude}`;
                });
                $store.classList.remove('dummy');
                $store.setAttribute('data-id', store.id);
                $store.querySelector('.name').innerHTML = store.name;
                if (store.logo) {
                    $store.querySelector('.logo').src = store.logo;
                    $store.querySelector('.logo').alt = `logo`;
                }
                $store.querySelector('.shop-address').innerHTML = store.address;
                $store.querySelector('.shop-phone a').href = `tel:${store.phone}`;
                $store.querySelector('.shop-phone a').innerHTML = `${store.phone}`;
                $store.querySelector('.shop-hours').innerHTML = getSchedule(store);
                $store.querySelector('.promotion-wrapper .links .storePage').href = `/spesa-e-servizi/punti-vendita/${store.id}/${store.name.replace(/[^a-zA-Z0-9\s\-_]/gmi, '').replace(/\s/gmi, '-')}`;
                const id = $store.getAttribute('data-id');
                localforage.getItem('favourite_store').then(stores => {
                    if (stores && stores.filter(s => s.id == id).length) {
                        $store.querySelector('.favourite-shop').classList.add('is-favourite');
                    }
                });
                storeRegistry[store.id] = store;
                return $store;
            }
            function bindActionsFavourite() {
                const $stores = $favouriteShop.querySelectorAll('.my-shop-card:not(.dummy)');
                $stores.forEach($store => {
                    const $hearth = $store.querySelector('.favourite-shop');
                    $hearth.addEventListener('click', () => {
                        const id = $store.getAttribute('data-id');
                        if ($hearth.classList.contains('is-favourite')) {
                            removeFavouriteStore(storeRegistry[id]);
                        }
                        else {
                            addFavouriteStore(storeRegistry[id]);
                        }
                        $hearth.classList.toggle('is-favourite');
                    });
                });
            }
            function addFavouriteStore(store) {
                localforage.getItem('favourite_store').then(stores => {
                    stores = stores || [];
                    stores.push(store);
                    localforage.setItem('favourite_store', stores);
                });
            }
            function removeFavouriteStore(store) {
                localforage.getItem('favourite_store').then(stores => {
                    stores = stores || [];
                    localforage.setItem('favourite_store', stores.filter(s => store.id !== s.id));
                });
            }
            function buildOffersHtml(offers) {
                const $carousel = $offersWrapper.querySelector('.train-card');
                const $slideContainer = $offersWrapper.querySelector('.slide-container');
                $slideContainer.innerHTML = '';
                if (offers.length) {
                    offers.forEach(offer => {
                        let $offer = $offerDummy.cloneNode(true);
                        if (offer.cover && offer.description) {
                            $offer.id = offer.idPromoRow;
                            $offer.querySelector('.image').style.backgroundImage = `url(${offer.cover})`;
                            $offer.querySelector('.card').href = offer.url;
                            $offer.querySelector('.container-text .title').innerHTML = offer.description;
                            $offer.querySelector('.container-text .description').innerHTML = `Dal ${moment(offer.startDate).format('DD/MM/yyyy')} al ${moment(offer.endDate).format('DD/MM/yyyy')}`;
                            $offersWrapper.querySelector('.slide-container').appendChild($offer);
                            $offer.classList.remove('dummy');
                        }
                        else {
                            viewOfferDefault(offer);
                        }
                    });
                    $offersWrapper.classList.add('is-active');
                }
                else {
                    $offersWrapper.classList.remove('is-active');
                }
                $offersWrapper.removeAttribute('data-spinner');
                trigger(document, 'init-train-card', $carousel);
            }
            function viewOfferDefault(offer) {
                let $noResultOffer = $offersWrapper.querySelector('.is-default-content');
                if ($noResultOffer) {
                    $noResultOffer = $noResultOffer.cloneNode(true);
                    $noResultOffer.classList.remove('dummy');
                    if (offer) {
                        $noResultOffer.querySelector('.card').href = offer.url;
                    }
                    $offersWrapper.querySelector('.slide-container').appendChild($noResultOffer);
                    $offersWrapper.classList.add('is-active');
                }
                else {
                    $offersWrapper.classList.remove('is-active');
                }
            }
            function buildServicesHtml(services) {
                const $carousel = $servicesWrapper.querySelector('.train-card');
                const $slideContainer = $servicesWrapper.querySelector('.slide-container');
                $slideContainer.innerHTML = '';
                if (services.length) {
                    services.forEach(service => {
                        const $service = $serviceDummy.cloneNode(true);
                        $service.id = service.id;
                        if (service.image) {
                            $service.querySelector('.image').src =
                                service.image;
                        }
                        $service.querySelector('.card-link').href =
                            service.link;
                        $service.querySelector('.card-description').innerHTML = service.text;
                        $service.classList.remove('dummy');
                        $servicesWrapper.querySelector('.slide-container').appendChild($service);
                    });
                    $servicesWrapper.classList.add('is-active');
                    $servicesWrapper.removeAttribute('data-spinner');
                    trigger(document, 'init-train-card', $carousel);
                }
                else {
                    $servicesWrapper.classList.remove('is-active');
                }
            }
            function build(stores) {
                const storesLen = stores.length;
                stores.forEach(store => {
                    const carouselItem = document.createElement('div');
                    const $store = buildStoreHtml($storeDummy, store);
                    carouselItem.className = 'carousel__item';
                    carouselItem.appendChild($store);
                    $storesWrapper.querySelector('.carousel').appendChild(carouselItem);
                });
                initCarousel();
                bindActionsFavourite();
                const activeStore = stores[activeStoreIndex];
                getOffers(activeStore.coopId, activeStore.id).then(promos => {
                    buildOffersHtml(promos);
                });
                getServices(activeStore.id, activeStore.geo).then(services => {
                    buildServicesHtml(services);
                });
                if (storesLen > 1) {
                    $next.classList.remove('hidden');
                    $prev.classList.remove('hidden');
                    $next.removeEventListener('click', () => { });
                    $next.addEventListener('click', () => {
                        activeStoreIndex = (activeStoreIndex + 1) % storesLen;
                        const activeStore = stores[activeStoreIndex];
                        getOffers(activeStore.coopId, activeStore.id).then(promos => {
                            buildOffersHtml(promos);
                        });
                        getServices(activeStore.id, activeStore.geo).then(services => {
                            buildServicesHtml(services);
                        });
                    });
                    $prev.removeEventListener('click', () => { });
                    $prev.addEventListener('click', () => {
                        activeStoreIndex = (activeStoreIndex - 1) % storesLen;
                        activeStoreIndex = activeStoreIndex < 0 ? storesLen - 1 : activeStoreIndex;
                        const activeStore = stores[activeStoreIndex];
                        getOffers(activeStore.coopId, activeStore.id).then(promos => {
                            buildOffersHtml(promos);
                        });
                        getServices(activeStore.id, activeStore.geo).then(services => {
                            buildServicesHtml(services);
                        });
                    });
                }
                else {
                    $next.classList.add('hidden');
                    $prev.classList.add('hidden');
                }
            }
            function reset(getClosest) {
                $offersWrapper.classList.remove('is-active');
                $servicesWrapper.classList.remove('is-active');
                $storesWrapper.querySelector('.carousel').innerHTML = '';
                $offersWrapper.querySelector('.slide-container').innerHTML = '';
                $servicesWrapper.querySelector('.slide-container').innerHTML = '';
                getStores(getClosest).then(stores => {
                    build(stores);
                });
            }
            function init() {
                getStores()
                    .then(stores => {
                    build(stores);
                    $button.classList.remove('d-none');
                })
                    .catch(() => {
                    showSearch();
                    $switchClosest.classList.remove('is-active');
                    $switchFavourite.classList.remove('is-active');
                    $button.classList.add('d-none');
                })
                    .finally(() => {
                    $favouriteShop.querySelector('.no-shop').removeAttribute('data-spinner');
                    $switchClosest.addEventListener('click', () => {
                        $switchClosest.classList.remove('is-active');
                        $titleFavourite.classList.add('d-none');
                        $titleClosest.classList.remove('d-none');
                        $next.classList.add('d-none');
                        $prev.classList.add('d-none');
                        reset(true);
                    });
                    $switchFavourite.addEventListener('click', () => {
                        $switchFavourite.classList.remove('is-active');
                        $titleFavourite.classList.remove('d-none');
                        $titleClosest.classList.add('d-none');
                        $next.classList.remove('d-none');
                        $prev.classList.remove('d-none');
                        reset(false);
                    });
                });
            }
            init();
        }
    });
})(FavouriteShop || (FavouriteShop = {}));
